/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useMemo } from 'react';
import {
  Table, Tag, Empty, Skeleton, Result, Pagination
} from 'antd';
import { v4 as uniqueId } from 'uuid';
import useFetchData from '../../hooks/useFetchData';
import QueryOptions from '../shared/QueryOptions';
import {
  formatDate, formatNumber, getCardTypeResponse, getRoleResponse
} from '../../utils/format';
import UserStatusUpdateModal from '../shared/UserStatusUpdateModal';

function UsersList({ add }) {
  const [fetchAgain, setFetchAgain] = useState(false);
  const [query, setQuery] = useState({
    search: '', sort: 'asce', page: '1', rows: '10'
  });
  const [statusUpdateModal, setStatusUpdateModal] = useState({ open: false, id: null, status: null });

  const [loading, error, response] = useFetchData(
    `/all-users-list?keyword=${query.search}&limit=${query.rows}&page=${query.page}&sort=${query.sort}`,
    fetchAgain
  );

  const handleTableChange = (pagination, filters) => {
    setColumnFilters({
      cardType: filters.cardType,
      role: filters.role ? filters.role[0] : null
    });
  };
  useEffect(() => {
    setQuery((prev) => ({ ...prev, page: '1' }));
  }, [query.rows, query.search]);

  // Générer les colonnes avec filtres
  const columns = useMemo(() => [
    {
      title: 'Carte',
      dataIndex: 'cardType',
      key: 'cardType',
      render: (_, record) => (
        <Tag color={getCardTypeResponse(record?.cardType)?.color} className='text-center '>
          <span
            dangerouslySetInnerHTML={{
              __html: getCardTypeResponse(record?.cardType)?.label
            }}
          />
        </Tag>
      )
    },
    {
      title: 'Téléphone',
      dataIndex: 'phone',
      key: 'phone',
      render: (phone) => formatNumber(phone)
    },
    {
      title: 'Nom',
      dataIndex: 'firstname',
      key: 'firstname',
      render: (_, record) => `${record.civility} ${record.firstname}`
    },
    {
      title: 'Quartier',
      dataIndex: 'quartier',
      key: 'quartier'
    },
    {
      title: 'Anniversaire',
      dataIndex: 'birthdate',
      key: 'birthdate',
      render: (date) => formatDate(date)
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      render: (role) => <Tag color={getRoleResponse(role).color}>{role}</Tag>

    }
  ], [response?.data?.rows]);

  return (
    <div>
      {/* Query options */}
      <QueryOptions query={query} setQuery={setQuery} />

      {error ? (
        <Result title='Failed to fetch' subTitle={error} status='error' />
      ) : (
        <Skeleton loading={loading} active paragraph={{ rows: 10 }}>
          {response?.data?.rows?.length === 0 ? (
            <Empty description='Sorry! Any data was not found.' />
          ) : (
            <Table
              rowKey={() => uniqueId()}
              columns={columns}
              dataSource={response?.data?.rows}
              pagination={false}
              onChange={handleTableChange}
              onRow={(record) => ({
                onClick: () => add(record._id, `${record.civility} ${record.firstname} ${record.quartier}`)
              })}
              scroll={{ x: 1000 }}
              bordered
            />
          )}
        </Skeleton>
      )}

      {/* Pagination */}
      {response?.data?.total_page > 1 && (
        <Pagination
          className='my-5'
          onChange={(e) => setQuery((prev) => ({ ...prev, page: e }))}
          total={response?.data?.total_page * 10}
          current={response?.data?.current_page}
        />
      )}

      {/* User status modal */}
      {statusUpdateModal?.open && (
        <UserStatusUpdateModal
          statusUpdateModal={statusUpdateModal}
          setStatusUpdateModal={setStatusUpdateModal}
          setFetchAgain={setFetchAgain}
        />
      )}
    </div>
  );
}

export default React.memo(UsersList);
